import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  titulo: {
    fontSize: '1.5625rem',
    fontWeight: 500,
    color: '#5e6784',
  },
  retangulo: {
    width: '266px',
    height: '103px',
    borderRadius: '4px',
    border: 'solid 1px #c2c4d1',
    cursor: 'pointer',
  },
  retanguloContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    height: '100%',
  },
  retanguloConteudo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '103px',
    justifyContent: 'center',
  },
  downloadIcon: {
    width: '24px',
    height: '24px',
    marginBottom: '9px',
    marginTop: '24px',
  },
  nomeArquivo: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#044ada',
    lineHeight: 1,
  },
  info: {
    marginBottom: '12px',
    textAlign: 'center',
  },
  informacoesAdicionais: {
    fontSize: '12px',
    color: '#5e6784',
  }
});

export default useStyles;
